/*!

=========================================================
* Now UI Dashboard React - v1.5.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container
} from "reactstrap";
import { useSelector } from "react-redux";
import routes from "routes.js";
import { BASE_URL } from "utils/constants";
import { SCHOOL_INFO } from "utils/constants";


function DemoNavbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [color, setColor] = React.useState(SCHOOL_INFO.color);
  const sidebarToggle = React.useRef();
  const permissions = useSelector((state) => state.permissions);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };

  const getBrand = () => {
    var name;
    routes.map((prop, key) => {
      if (prop.collapse) {
        prop.views.map((prop, key) => {
          if (prop.path === window.location.pathname) {
            name = prop.name;
          }
          return null;
        });
      } else {
        if (prop.redirect) {
          if (prop.path === window.location.pathname) {
            name = prop.name;
          }
        } else {
          if (prop.path === window.location.pathname) {
            name = prop.name;
          }
        }
      }
      return null;
    });
    return name;
  };

  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    // sidebarToggle.current.classList.toggle("toggled");
  };

  // function that adds color white/school color to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("white");
    } else {
      setColor(SCHOOL_INFO.color);
    }
  };

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
  }, []);

  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);
  
  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color={
        window.location.pathname.indexOf("full-screen-maps") !== -1
          ? "white"
          : color
      }
      expand="lg"
      className={
        window.location.pathname.indexOf("full-screen-maps") !== -1
          ? "navbar-absolute fixed-top"
          : "navbar-absolute fixed-top "
      }
      style={{ backgroundColor: `${SCHOOL_INFO.color} !important` }}
    >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => openSidebar()}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
        </div>
        <NavbarToggler onClick={toggle}>
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </NavbarToggler>
        <Collapse isOpen={isOpen} navbar className="justify-content-end fw-bold">

          <Nav navbar>
            {/* <NavItem>
              <Link to="#pablo" className="nav-link">
                <i className="now-ui-icons ui-2_chat-round" />
                <p>
                  <span className="d-lg-none d-md-block">Chat</span>
                </p>
              </Link>
            </NavItem> */}
            <NavItem>
              <a href="https://outlook.office365.com" target="_blank" className="nav-link">
                <i className="now-ui-icons ui-1_email-85" />
                <p>
                  <span className="d-lg-none d-md-block">Mail</span>
                </p>
              </a>
            </NavItem>
            <Dropdown
              nav
              isOpen={dropdownOpen}
              toggle={(e) => dropdownToggle(e)}
            >
              <DropdownToggle caret nav>
                <i className="now-ui-icons users_single-02" />
                <p>
                  <span className="d-lg-none d-md-block">Account</span>
                </p>
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem><span className="mr-2 d-none d-lg-inline small cadet fs-6">{permissions.ivyemail}</span></DropdownItem>
                <DropdownItem tag={Link} to="/studentcard"><i className="now-ui-icons business_badge" />&nbsp;&nbsp;View Card</DropdownItem>
                <DropdownItem tag="a"><button className="btn btn-primary fs-6 fw-bolder" onClick={() => window.location.replace(`${BASE_URL}/logout.php`)} ><i className="fas fa-sign-out-alt"></i> &nbsp;&nbsp;Sign Out</button></DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
}

export default DemoNavbar;
